import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-form/form.min.js'
import {
  TRIGGER_NAME_DUPLICATE,
  TRIGGER_NAME_REQUIRED,
  TRIGGER_NAME_TOO_LONG,
  trans
} from '../../translator'

declare const $: any

let originalTriggerName: string | null = null

$.fn.form = require('semantic-ui-form')
$.fn.transition = require('semantic-ui-transition')
$.fn.form.settings.rules.uniqueTriggerName = function (value: string): boolean {
  if (value === '' || value.trim() === originalTriggerName?.trim()) {
    return true
  }

  const triggerNames: string[] = []
  $('.trigger-name').each(function (this: HTMLElement) {
    triggerNames.push($(this).text().trim())
  })

  return $.grep(triggerNames, function (triggerName: string) {
    return triggerName.toLowerCase().trim() === value.toLowerCase().trim()
  }).length === 0
}

export default class IndexTriggerController extends Controller {
  static targets = [
    'createModal', 'editModal', 'deleteModal', 'deleteConfirmButton'
  ]

  declare readonly createModalTarget: HTMLElement
  declare readonly editModalTarget: HTMLElement
  declare readonly deleteModalTarget: HTMLElement
  declare readonly deleteConfirmButtonTarget: HTMLAnchorElement

  private createModal!: Modal
  private editModal!: Modal
  private deleteModal!: Modal

  connect (): void {
    $('table tbody').sortable({
      handle: '.sortable-handle'
    })
    $('table tbody').on('sortupdate', (ev: Event, ui: { item: HTMLElement[] }) => {
      $.ajax({
        url: `/internal/api/triggers/${(ui.item[0] as HTMLElement).dataset.triggerId}/reorder`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          position: $(ui.item[0]).index()
        })
      })
    })

    this.createModal = new Modal(this.createModalTarget)
    this.editModal = new Modal(this.editModalTarget)
    this.deleteModal = new Modal(this.deleteModalTarget)

    $(document.forms.namedItem('create_trigger') as HTMLFormElement).form({
      fields: {
        create_trigger_name: {
          identifier: 'create_trigger_name',
          rules: [
            {
              type: 'empty',
              prompt: trans(TRIGGER_NAME_REQUIRED, {}, 'triggers')
            },
            {
              type: 'maxLength[255]',
              prompt: trans(TRIGGER_NAME_TOO_LONG, {}, 'triggers')
            },
            {
              type: 'uniqueTriggerName',
              prompt: trans(TRIGGER_NAME_DUPLICATE, {}, 'triggers')
            }
          ]
        }
      },
      inline: true
    })

    $(document.forms.namedItem('edit_trigger') as HTMLFormElement).form({
      fields: {
        edit_trigger_name: {
          identifier: 'edit_trigger_name',
          rules: [
            {
              type: 'empty',
              prompt: trans(TRIGGER_NAME_REQUIRED, {}, 'triggers')
            },
            {
              type: 'maxLength[255]',
              prompt: trans(TRIGGER_NAME_TOO_LONG, {}, 'triggers')
            },
            {
              type: 'uniqueTriggerName',
              prompt: trans(TRIGGER_NAME_DUPLICATE, {}, 'triggers')
            }
          ]
        }
      },
      inline: true
    })
  }

  create (event?: Event): void {
    event?.preventDefault()

    originalTriggerName = null

    const form = document.forms.namedItem('create_trigger') as HTMLFormElement
    $(form).form('set values', {
      'create_trigger[name]': ''
    })
    this.createModal.show()
  }

  edit (event: Event): void {
    event.preventDefault()

    const row = (event.currentTarget as HTMLElement).closest('tr') as HTMLElement
    const triggerId = row.dataset.triggerId
    const triggerName = row.dataset.triggerName ?? ''
    originalTriggerName = triggerName

    const form = document.forms.namedItem('edit_trigger') as HTMLFormElement
    $(form).form('set values', {
      'edit_trigger[name]': triggerName,
      'edit_trigger[originalTrigger]': triggerId
    })

    this.editModal.show()
  }

  submitEdit (): void {
    const form = document.forms.namedItem('edit_trigger') as HTMLFormElement
    const updatedName = (form.elements.namedItem('edit_trigger[name]') as HTMLInputElement).value

    if (updatedName.trim() === originalTriggerName?.trim()) {
      this.editModal.hide()
      return
    }

    $(form).form('validate form')
    if ($(form).form('is valid')) {
      form.submit()
    }
  }

  delete (event: Event & { params: { url: string } }): void {
    event.preventDefault()
    this.deleteConfirmButtonTarget.href = event.params.url
    this.deleteModal.show()
  }
}
